import { faChevronRight } from '@fortawesome/pro-solid-svg-icons/faChevronRight';
import { createFileRoute } from '@tanstack/react-router';
import { useFlagsStatus } from '@unleash/proxy-client-react';
import useResponsive from 'ahooks/es/useResponsive';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import { FontAwesomeIcon } from '#/components/FontAwesomeIcon';
import ExploreEventsListing from '@/components/_events/ExploreEventsListing.tsx';
import ExplorePage from '@/components/_explore/ExplorePage.tsx';
import LinkButton from '@/components/LinkButton';
import { ExploreLayout } from '@/components/layouts/index.tsx';
import PageLoading from '@/components/loading/PageLoading.tsx';
import PageDisabled from '@/components/PageDisabled.tsx';
import useFlag from '@/lib/hooks/useFlag.ts';

const Meetups = () => {
  const featuresReady = useFlagsStatus().flagsReady;
  const enableExplore = useFlag('explore');
  const { t } = useTranslation(['common', 'event']);
  const { xl } = useResponsive();

  if (!featuresReady) {
    return <PageLoading />;
  }
  if (!enableExplore) {
    return <PageDisabled absolutelyCentered />;
  }

  return (
    <ExplorePage
      isSubPage
      title="explore:meetups"
      rightHeaderContent={
        <LinkButton
          to="/explore/community-meetups"
          className={clsx('ml-auto d-inline mr-0')}
          variant="info"
          size={xl ? 'xl' : undefined}
        >
          {t('event:button.community_meetups')}
          <FontAwesomeIcon icon={faChevronRight} size="lg" className="mx-0 ms-2" />
        </LinkButton>
      }
    >
      <ExploreEventsListing types={['meetup']} />
    </ExplorePage>
  );
};

export const Route = createFileRoute('/explore/meetups')({
  component: () => (
    <ExploreLayout title="explore:meetups">
      <Meetups />
    </ExploreLayout>
  ),
});
